import { render } from "./saveTea.vue?vue&type=template&id=5844c004&scoped=true"
import script from "./saveTea.vue?vue&type=script&lang=js"
export * from "./saveTea.vue?vue&type=script&lang=js"

import "./saveTea.vue?vue&type=style&index=0&id=5844c004&scoped=true&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5844c004"]])

export default __exports__